import React, { useEffect, useState, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-draw";
import "leaflet-draw/dist/leaflet.draw.css";
import NDVIChart from "../NDVIChart/NDVIChart";
import "./AllChart.css";
import ProgressBar from "../Loader/ProgressBar";
import { Button } from "react-bootstrap";
import WeatherDetailsView from "../WeatherDetails/WeatherDetails";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch, useStore } from "react-redux";
import {
  setStateName,
  setDistrictName,
  setTehsilName,
  setVillageName,
} from "../../features/location/locationSlice";
import {
  setSelectedIndices,
  setSelectedSeason,
  setSelectedYear,
  setStartDate,
  setEndDate,
  setChartData,
  resetIndicesState,
} from "../../features/indices/indicesSlice";
import {
  fetchDistricts,
  fetchTehsils,
  fetchVillages,
} from "../../features/geo/geoSlice";
import { getTehsilName } from "../../utils/name";
import { waitForCondition, triggerLayerClickSafely, safeFitBounds } from "../../utils/mapHelpers";
import { GEO_SERVER_BASE_URL } from "../../config/constants";
import SelectionDropdown from "../SelectionDropdown";
import ReactDOM from "react-dom";
import LZString from "lz-string";
import { createRoot } from "react-dom/client";
import Papa from "papaparse";
import Spinner from "../Loader/Spinner";
import "../Loader/Spinner.css";
import ScoreCard from "../all-charts/Scorecard";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// NEW: Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const IndicesAnalytics = () => {
  const mapRef = useRef(null);
  const loadingRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const [isDropdownLoading, setIsDropdownLoading] = useState(false);
  const khasraHighlightRef = useRef(null);
  const [showDEMView, setShowDEMView] = useState(false);
  const [selectedPolygon, setSelectedPolygon] = useState(null);
  const [weatherData, setWeatherData] = useState([]);
  const [khasraNumber, setKhasraNumber] = useState("");
  const [demImage, setDemImage] = useState(null);
  const [cropData, setCropData] = useState([]);
  const [showLULC, setShowLULC] = useState(false);
  const isKhasraWMSActiveRef = useRef(false);
  const hasShownKhasraTileErrorRef = useRef(false);


  const cache = useRef({
    states: {},
    districts: {},
    tehsils: {},
    villages: {},
    stateGeoData: {},
    tehsilGeoData: {},
    villageGeoData: {},
  });

  const lulcLayerRef = useRef(null);
  const [selectedCrop, setSelectedCrop] = useState(null);
  const [selectedStateLayer, setSelectedStateLayer] = useState(null);
  const [isDEMEnabled, setIsDEMEnabled] = useState(false);
  const [showWeather, setShowWeather] = useState(false);
  const [showMapView, setShowMapView] = useState(false);
  const currentVillageLayerRef = useRef(null);
  const currentKhasraLayerRef = useRef(null);
  const currentTehsilLayersRef = useRef([]);
  const [isKhasraVisible, setIsKhasraVisible] = useState(false);


  const navigate = useNavigate();
  const {
    selectedIndices,
    selectedSeason,
    selectedYear,
    startDate,
    endDate: selectedDate,
    chartData,
  } = useSelector((state) => state.indices);
  const location = useLocation();

  const [forceRender, setForceRender] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const showInfo = useRef(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const store = useStore(); // ✅ Direct store access for Condition 2 fallback
  const {
    state: selectedState,
    district: selectedDistrict,
    tehsil: selectedTehsil,
    village: villageName,
  } = useSelector((s) => s.location);

  // ✅ CONDITION 2 GUARD: true = "already done" (skip). Starts as true for Condition 1 (empty villageName at mount).
  // For Condition 2 (villageName pre-set at mount), starts as false so auto-trigger fires once then resets.


  // ✅ REDUX GEO INTEGRATION
  const { lists, geojson, loading: geoLoading } = useSelector((s) => s.geo);

  // Map Redux lists to local variables for compatibility
  const districts = lists.districts;
  const tehsils = lists.tehsils;
  const villages = lists.villages;
  const tehsilData = geojson.tehsil;

  const [geoJsonLayer, setGeoJsonLayer] = useState(null);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [tooltipPos, setTooltipPos] = useState({ top: 0, left: 0 });
  const [isKhasraSearchEnabled, setIsKhasraSearchEnabled] = useState(false);
  const [geoData, setGeoData] = useState(null);
  const [villageGeoData, setvillageGeoData] = useState(null);
  // const [districts, setDistricts] = useState([]); // REMOVED
  const [isSatelliteVisible, setIsSatelliteVisible] = useState(true);
  const satelliteLayerRef = useRef(null);
  // const [tehsils, setTehsils] = useState([]); // REMOVED
  // const [villages, setVillages] = useState([]); // REMOVED
  const [tehsilLayer, setTehsilLayer] = useState(null);
  // const [tehsilData, settehsilData] = useState(null); // REMOVED
  const [villageGeoJson, setVillageGeoJson] = useState("");
  const [selectedStateStateLayer, setSelectedStateStateLayer] = useState(null);
  const [selectedDistrictLayer, setSelectedDistrictLayer] = useState(null);
  const [selectedDistrictTehsilLayer, setSelectedDistrictTehsilLayer] =
    useState(null);
  const [mapReady, setMapReady] = useState(false); // ✅ Fix: Sync map init with layer effects

  // Missing state variables restored
  const [khasraGeoJson, setKhasraGeoJson] = useState(null);
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
    isMobile: window.innerWidth <= 768,
    isTablet: window.innerWidth <= 1024,
    isSmallLaptop: window.innerWidth <= 1400,
  });
  const [progress, setProgress] = useState(0);
  const latestParamsRef = useRef({
    selectedState,
    selectedDistrict,
    selectedTehsil,
    villageName,
    selectedSeason,
    selectedYear,
    startDate,
    selectedDate,
  }); // ✅ Fix: Handle stale closures in map callbacks
  // 🔧 CONDITION-2 FIX
  // When season/year/date changes, force selected polygon to re-fetch on next click
  useEffect(() => {
    if (!currentVillageLayerRef.current) return;

    currentVillageLayerRef.current.eachLayer((layer) => {
      if (layer && layer.selected) {
        layer._lastRequestKey = null;
        console.log("♻️ Reset polygon request cache due to season/year change");
      }
    });
  }, [selectedSeason, selectedYear, startDate, selectedDate]);

  const [seasonalScores, setSeasonalScores] = useState({});

  // getDistrictName / getTehsilName now imported from utils/name.js

  const toggleDrawer = () => {
    setIsDrawerOpen((prevState) => {
      const newState = !prevState;
      setTimeout(
        () => {
          if (mapInstanceRef.current) {
            mapInstanceRef.current.invalidateSize();
          }
        },
        screenSize.isMobile ? 100 : 350
      );
      return newState;
    });
  };

  const toggleLegendInfo = () => {
    showInfo.current = !showInfo.current;
    setForceRender((prev) => !prev);
  };

  const tooltipTexts = {
    NDVI: "NDVI (Normalized Difference Vegetation Index): is a widely-used metric for quantifying the health and density of vegetation using sensor data. It is calculated from spectrometric data at two specific bands: red and near-infrared.",
    NDMI: "NDMI (Normalized Difference Moisture Index):NDMI is similar to NDWI but specifically targets moisture levels in vegetation rather than in soil or water bodies. ",
    EVI: "EVI (Enhanced Vegetation Index): EVI is an enhanced version of NDVI, designed to optimize vegetation signal strength while reducing atmospheric and soil background noise. ",
    SVHI: "SVHI (Seasonal Vegetation Health Index): SVHI is a composite index that combines multiple vegetation indices to assess the overall health and productivity of vegetation over a specific season.",
  };


  // ... (keeping other unrelated states)

  // ✅ RESTORED MAP INITIALIZATION
  useEffect(() => {
    if (mapInstanceRef.current) return;

    const map = L.map(mapRef.current, {
      center: [20, 78], // Default to India (matches DEMView)
      zoom: 5,
      zoomControl: false,
      attributionControl: false,
      fadeAnimation: false, // 🚀 Fix: Prevent 'Cannot read properties of null (reading _fadeAnimated)' error
    });

    const satelliteLayer = L.tileLayer(
      "https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
      {
        maxZoom: 20,
        subdomains: ["mt0", "mt1", "mt2", "mt3"],
        attribution: "Google Satellite",
      }
    );

    satelliteLayer.addTo(map);
    satelliteLayerRef.current = satelliteLayer;

    L.control.zoom({ position: "bottomright" }).addTo(map);

    mapInstanceRef.current = map;
    setMapReady(true); // ✅ Fix: Signal that map is ready for layers

    // Add scale control
    L.control.scale({ position: "bottomright" }).addTo(map);

    // Initial boundary fit if state is already selected
    // (This part is handled by other effects, but good to have map ready)

    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
        setMapReady(false);
      }
    };
  }, []);

  // ✅ SYNC PARAMS REF (Prevents stale closures in Leaflet callbacks)
  useEffect(() => {
    latestParamsRef.current = {
      selectedState,
      selectedDistrict,
      selectedTehsil,
      villageName,
      selectedSeason,
      selectedYear,
      startDate,
      selectedDate,
    };
  }, [
    selectedState,
    selectedDistrict,
    selectedTehsil,
    villageName,
    selectedSeason,
    selectedYear,
    startDate,
    selectedDate,
  ]);

  // ✅ CONSOLIDATED FETCH LOGIC (Ensures all levels fetch if navigating with pre-filled state)
  useEffect(() => {
    if (!selectedState) return;

    // 1. Districts
    if (selectedState && (!lists.districts || lists.districts.length === 0)) {
      dispatch(fetchDistricts(selectedState));
    }

    // 2. Tehsils
    if (selectedState && selectedDistrict && (!lists.tehsils || lists.tehsils.length === 0)) {
      dispatch(fetchTehsils({ stateName: selectedState, district: selectedDistrict }));
    }

    // 3. Villages
    if (selectedState && selectedDistrict && selectedTehsil) {
      // We always fetch villages for the tehsil to ensure GeoJSON is present for rendering
      dispatch(fetchVillages({
        stateName: selectedState,
        district: selectedDistrict,
        tehsil: selectedTehsil
      }));
    }
  }, [selectedState, selectedDistrict, selectedTehsil, dispatch]);

  // ✅ DEFAULT YEAR/SEASON SETTINGS (Required for auto-fetch baseline)
  useEffect(() => {
    if (selectedState && !selectedSeason && !selectedYear) {
      console.log("📅 AllChart: Setting default year/season for", selectedState);
      if (selectedState === "Rajasthan") {
        dispatch(setSelectedSeason("Rabi"));
        dispatch(setSelectedYear("2025"));
        dispatch(setStartDate("2024-11-01"));
        dispatch(setEndDate("2025-04-15"));
      } else if (selectedState === "Maharashtra") {
        dispatch(setSelectedSeason("Rabi"));
        dispatch(setSelectedYear("2024"));
        dispatch(setStartDate("2023-11-15"));
        dispatch(setEndDate("2024-04-15"));
      }
    }
  }, [selectedState, selectedSeason, selectedYear, dispatch]);

  // ✅ HANDLE TEHSIL MAP LAYER (Responding to Redux geojson.tehsil)
  useEffect(() => {
    if (!mapReady || !tehsilData || !mapInstanceRef.current) return;

    // ✅ Match CHMPage logic: If a village is selected, HIDE the tehsil layer
    if (villageName) {
      if (cache.current.tehsilLayer) {
        mapInstanceRef.current.removeLayer(cache.current.tehsilLayer);
        cache.current.tehsilLayer = null;
      }
      // Note: We used to clear geoJsonLayer here, but that's the Village Layer!
      // Removing it caused the Village boundary to disappear.
      return;
    }

    // Clear existing tehsil layer if any
    if (cache.current.tehsilLayer) {
      mapInstanceRef.current.removeLayer(cache.current.tehsilLayer);
    }

    const newTehsilLayer = L.geoJSON(tehsilData, {
      interactive: false,
      style: (feature) => {
        const tName = feature.properties.tehsil || feature.properties.Tehsil;
        const isSelected = selectedTehsil && tName?.toLowerCase() === selectedTehsil.toLowerCase();
        return {
          color: isSelected ? "#DC2626" : "#FB923C", // Red if selected, Orange if not
          weight: isSelected ? 3 : 1,
          fillOpacity: isSelected ? 0.1 : 0,
          fillColor: isSelected ? "#DC2626" : "transparent"
        };
      },
      onEachFeature: (feature, layer) => {
        const tehsilLabel = getTehsilName(feature);
        layer.bindTooltip(tehsilLabel, {
          permanent: false,
          direction: "top",
        });

        layer.once("add", () => {
          const el = layer.getElement?.();
          if (el) {
            el.style.pointerEvents = currentKhasraLayerRef.current ? "none" : "auto";
          }
        });
      },
    });

    newTehsilLayer.addTo(mapInstanceRef.current);

    // ✅ Auto-zoom to selected Tehsil (only if no village selected)
    if (selectedTehsil) {
      const selectedFeature = tehsilData.features.find(f => {
        const tName = f.properties.tehsil || f.properties.Tehsil;
        return tName?.toLowerCase() === selectedTehsil.toLowerCase();
      });
      if (selectedFeature) {
        const tempLayer = L.geoJSON(selectedFeature);
        mapInstanceRef.current.fitBounds(tempLayer.getBounds(), { padding: [20, 20] });
      } else {
        mapInstanceRef.current.fitBounds(newTehsilLayer.getBounds(), { padding: [20, 20] });
      }
    }

    setTehsilLayer(newTehsilLayer);
    cache.current.tehsilLayer = newTehsilLayer;

  }, [tehsilData, selectedTehsil, villageName, mapReady]);





  // ✅ LEGACY FETCH REMOVED: Replaced by Redux fetchVillages and geojson stream


  // ✅ HANDLE VILLAGE MAP LAYER & AUTO-SELECTION
  useEffect(() => {
    const villageData = geojson.village;

    if (!mapReady || !villageData || !mapInstanceRef.current || !selectedTehsil) {
      return;
    }

    if (currentVillageLayerRef.current) {
      mapInstanceRef.current.removeLayer(currentVillageLayerRef.current);
      currentVillageLayerRef.current = null;
    }

    // ✅ RESTORE CONTEXT: Show all villages, but restrict interactivity
    const newVillageLayer = L.geoJSON(villageData, {
      interactive: true,

      style: (feature) => {
        const pName =
          feature.properties.village ||
          feature.properties.NAME ||
          feature.properties.Name;

        const isSelected =
          villageName &&
          pName?.toLowerCase().trim() ===
          villageName.toLowerCase().trim();

        // If village selected: Highlight selected, Fade others
        return {
          color: isSelected ? "#7C3AED" : "#F97316",
          weight: isSelected ? 4 : 1.5,
          fillOpacity: isSelected ? 0.35 : 0,
          fillColor: isSelected ? "#7C3AED" : "transparent",
          opacity: 1
        };

      },

      onEachFeature: (feature, layer) => {
        const pName =
          feature.properties.village ||
          feature.properties.NAME ||
          feature.properties.Name;

        // bind tooltip regardless
        layer.bindTooltip(pName, { direction: "center" });

        // Force pointer events
        layer.once("add", () => {
          const el = layer.getElement?.();
          if (el) el.style.pointerEvents = "auto";
        });

        /*
         THIS is the important part
         */
        layer.on("click", (e) => {
          // ✅ FIX: If Khasra is active, let click propagate to map so Khasra popup works!
          if (isKhasraWMSActiveRef.current) {
            console.log("🖱️ Village clicked, but Khasra is active — propagating event.");
            return; // Don't stop propagation, don't trigger village stats
          }

          L.DomEvent.stopPropagation(e);
          console.log("Village clicked:", pName);
          handlePolygonClick(feature, layer, false);
        });
      },
    });


    newVillageLayer.addTo(mapInstanceRef.current);
    currentVillageLayerRef.current = newVillageLayer;

    if (villageName) {
      const selectedLayer = newVillageLayer
        .getLayers()
        .find((l) => {
          const f = l.feature;
          const p =
            f.properties.village ||
            f.properties.NAME ||
            f.properties.Name;
          return (
            p?.toLowerCase().trim() ===
            villageName.toLowerCase().trim()
          );
        });

      if (selectedLayer) {
        mapInstanceRef.current.fitBounds(selectedLayer.getBounds(), {
          padding: [40, 40],
        });

        // ✅ RESTORE SELECTION: If coming from weather page, re-set the selectedPolygon
        const fromWeather = sessionStorage.getItem("fromWeather") === "true";
        if (fromWeather && !selectedPolygon) {
          console.log("🎯 [AllChart] Restoring selected polygon for:", villageName);
          selectedLayer.setStyle({
            color: "#7C3AED",
            weight: 5,
            fillOpacity: 0.3,
            fillColor: "#7C3AED",
          });
          setSelectedPolygon(selectedLayer);
          selectedLayer.selected = true;
          
          // Set request key to prevent immediate re-fetch if redundant
          selectedLayer._lastRequestKey = `${selectedSeason || "none"}::${startDate || "none"}::${selectedDate || "none"}::${villageName.toString().trim().toLowerCase()}`;
          
          // Clear the flag now that restoration is attempted
          sessionStorage.removeItem("fromWeather");
        }

        // ✅ FIX: ensure selected polygon always receives clicks (Condition-2)
        selectedLayer.off("click");
        selectedLayer.on("click", (e) => {
          if (isKhasraWMSActiveRef.current) return;
          L.DomEvent.stopPropagation(e);
          console.log("🖱️ Condition-2 manual click detected");
          handlePolygonClick(selectedLayer.feature, selectedLayer, false);
        });



      }
    } else {
      mapInstanceRef.current.fitBounds(newVillageLayer.getBounds(), {
        padding: [20, 20],
      });
    }

  }, [geojson.village, villageName, selectedTehsil, mapReady]);




  const handleStateChange = (e) => {
    const newState = e.target.value;
    if (newState === selectedState) return;

    // 1. Dispatch Redux state update (locationSlice clears downstream automatically)
    dispatch(setStateName(newState));
    localStorage.setItem("selectedState", newState);

    // 2. Clear downstream localStorage
    localStorage.removeItem("selectedDistrict");
    localStorage.removeItem("selectedTehsil");
    localStorage.removeItem("selectedVillage");

    // 3. Proactively fetch districts for the new state
    dispatch(fetchDistricts(newState));



    // 5. Set default season/dates per state
    if (newState === "Rajasthan") {
      dispatch(setSelectedSeason("Rabi"));
      dispatch(setSelectedYear("2025"));
      dispatch(setStartDate("2024-11-01"));
      dispatch(setEndDate("2025-04-15"));
    } else if (newState === "Maharashtra") {
      dispatch(setSelectedSeason("Rabi"));
      dispatch(setSelectedYear("2024"));
      dispatch(setStartDate("2023-11-15"));
      dispatch(setEndDate("2024-04-15"));
    }
  };

  // ✅ CLEAR CHART DATA ON MOUNT (Conditional)
  useEffect(() => {
    const fromWeather = sessionStorage.getItem("fromWeather") === "true";
    if (!fromWeather) {
      console.log("🔄 [AllChart] Resetting indices state (not from weather page)");
      dispatch(resetIndicesState());
      setSelectedPolygon(null);
    } else {
      console.log("♻️ [AllChart] Preserving state (returning from weather page)");
      // We keep the flag for the layer-loading effect to use, 
      // it will be cleared there once the plot is restored.
    }
  }, [dispatch]);

  // ✅ Auto-fetch and render state boundary on state change (navigation or dropdown)
  useEffect(() => {
    const fetchStateBoundary = async () => {
      if (!selectedState || !mapInstanceRef.current) return;

      // Clear existing layers to prevent overlap
      if (currentTehsilLayersRef.current && currentTehsilLayersRef.current.length > 0) {
        currentTehsilLayersRef.current.forEach((layer) =>
          mapInstanceRef.current.removeLayer(layer)
        );
        currentTehsilLayersRef.current = [];
      }
      if (currentVillageLayerRef.current) {
        mapInstanceRef.current.removeLayer(currentVillageLayerRef.current);
        currentVillageLayerRef.current = null;
      }

      setIsDropdownLoading(true);
      try {
        const stateCacheKey = `state_${selectedState}`;
        let stateData;

        if (cache.current.stateGeoData[stateCacheKey]) {
          stateData = cache.current.stateGeoData[stateCacheKey];
        } else {
          const response = await fetch(
            `/geodata/state?state=${encodeURIComponent(selectedState)}`
          );
          if (!response.ok) throw new Error("Failed to fetch state boundary");
          stateData = await response.json();
          cache.current.stateGeoData[stateCacheKey] = stateData;
        }

        const stateLayer = L.geoJSON(stateData, {
          interactive: false,
          style: function (feature) {
            const districtName = feature.properties.District || feature.properties.district || "";
            // Match DEMView: Blue if selected, Red if not
            const isSelected = selectedDistrict &&
              (districtName.toLowerCase().trim() === selectedDistrict.toLowerCase().trim());

            return {
              color: isSelected ? "blue" : "red",
              weight: isSelected ? 3 : 1,
              fillOpacity: 0
            };
          },
          onEachFeature: function (feature, layer) {
            const districtName = feature.properties.District || feature.properties.district || "Unknown District";
            // Match DEMView: plain district label
            layer.bindTooltip(districtName, {
              permanent: true,
              direction: "center",
              className: "district-label",
            });
          },
        });

        if (selectedStateLayer) {
          mapInstanceRef.current.removeLayer(selectedStateLayer);
        }

        stateLayer.addTo(mapInstanceRef.current);
        // Only fit bounds to state if no district is selected
        if (!selectedDistrict) {
          mapInstanceRef.current.fitBounds(stateLayer.getBounds());
        }
        setSelectedStateLayer(stateLayer);
        setIsDEMEnabled(true);
      } catch (error) {
        console.error("Error fetching state boundary:", error);
      } finally {
        setIsDropdownLoading(false);
      }
    };

    fetchStateBoundary();
  }, [selectedState, selectedDistrict]); // ✅ Added selectedDistrict dependency for color updates

  // ✅ Handle District Selection (Zoom to District Boundary)
  // Now fetches state GeoJSON if not cached, so zoom always works even on Condition 2.
  useEffect(() => {
    if (!selectedDistrict || !mapInstanceRef.current || !mapReady || !selectedState) return;

    // Only zoom to district if no tehsil is selected (District View)
    if (selectedTehsil) return;

    const zoomToDistrictAndHighlight = async () => {
      const map = mapInstanceRef.current;
      if (!map) return;

      // Clear lower levels
      if (currentVillageLayerRef.current) {
        map.removeLayer(currentVillageLayerRef.current);
        currentVillageLayerRef.current = null;
      }

      // Remove previous district highlight layer
      if (selectedDistrictLayer) {
        try { map.removeLayer(selectedDistrictLayer); } catch (_) { }
      }

      // Get state geo data — fetch if not cached
      const stateCacheKey = `state_${selectedState}`;
      let stateData = cache.current.stateGeoData[stateCacheKey];

      if (!stateData) {
        try {
          const response = await fetch(
            `/geodata/state?state=${encodeURIComponent(selectedState)}`
          );
          if (!response.ok) throw new Error("Failed to fetch state boundary");
          stateData = await response.json();
          cache.current.stateGeoData[stateCacheKey] = stateData;
        } catch (error) {
          console.error("Error fetching state GeoJSON for district zoom:", error);
          return;
        }
      }

      // Bail if selection changed while fetching
      if (!mapInstanceRef.current) return;

      // Find the district feature
      const districtFeature = stateData.features?.find(f => {
        const dName = f.properties.District || f.properties.district || "";
        return dName.trim().toLowerCase() === selectedDistrict.trim().toLowerCase();
      });

      if (!districtFeature) {
        console.warn("District feature not found in state GeoJSON:", selectedDistrict);
        return;
      }

      // Create a real L.geoJSON layer for the district and zoom to it
      const distLayer = L.geoJSON(districtFeature, {
        interactive: false,
        style: { color: "#312E81", weight: 3, fillOpacity: 0.08, fillColor: "#312E81" }
      });

      distLayer.addTo(map);
      setSelectedDistrictLayer(distLayer);

      // fitBounds with safety check
      try {
        const bounds = distLayer.getBounds();
        if (bounds && bounds.isValid()) {
          map.fitBounds(bounds, { padding: [30, 30] });
        }
      } catch (e) {
        console.warn("fitBounds failed for district layer:", e);
      }

      console.log("📍 District zoom complete:", selectedDistrict);
    };

    zoomToDistrictAndHighlight();
  }, [selectedDistrict, selectedTehsil, selectedState, mapReady]);

  const handleDistrictChange = (event) => {
    const newDistrict = event.target.value;
    if (!newDistrict) return;

    // 1. Dispatch Redux updates (locationSlice clears downstream)
    dispatch(setDistrictName(newDistrict));
    localStorage.setItem("selectedDistrict", newDistrict);

    // 2. Clear downstream localStorage
    localStorage.removeItem("selectedTehsil");
    localStorage.removeItem("selectedVillage");

    // 3. Proactively fetch tehsils for this district
    dispatch(fetchTehsils({ stateName: selectedState, district: newDistrict }));


  };

  const handleTehsilChange = (e) => {
    const tehsilValue = e.target.value.trim();
    if (!tehsilValue) return;

    // 1. Dispatch Redux updates (locationSlice clears village)
    dispatch(setTehsilName(tehsilValue));
    localStorage.setItem("selectedTehsil", tehsilValue);
    localStorage.removeItem("selectedVillage");

    // 2. Proactively fetch villages for this tehsil
    dispatch(fetchVillages({ stateName: selectedState, district: selectedDistrict, tehsil: tehsilValue }));



    // 4. Zoom to tehsil boundary if layer exists
    if (tehsilLayer && tehsilValue) {
      const matchingLayer = tehsilLayer.getLayers().find((layer) => {
        const tehsilProp = getTehsilName(layer.feature)?.toLowerCase().trim();
        return tehsilProp === tehsilValue.toLowerCase().trim();
      });

      if (matchingLayer) {
        safeFitBounds(mapInstanceRef.current, matchingLayer, { padding: [20, 20] });
        matchingLayer.setStyle({
          color: "orange",
          weight: 3,
          fillOpacity: 0.2,
        });
      }
    }
  };

  const clearCache = () => {
    cache.current = {
      states: {},
      districts: {},
      tehsils: {},
      villages: {},
      stateGeoData: {},
      tehsilGeoData: {},
      villageGeoData: {},
    };
  };

  const getCacheStats = () => {
    const stats = {
      states: Object.keys(cache.current.states).length,
      districts: Object.keys(cache.current.districts).length,
      tehsils: Object.keys(cache.current.tehsils).length,
      villages: Object.keys(cache.current.villages).length,
      stateGeoData: Object.keys(cache.current.stateGeoData).length,
      tehsilGeoData: Object.keys(cache.current.tehsilGeoData).length,
      villageGeoData: Object.keys(cache.current.villageGeoData).length,
    };
    return stats;
  };

  const preloadFrequentStates = async () => {
    const frequentStates = ["Rajasthan", "Maharashtra", "Uttar Pradesh"];

    for (const state of frequentStates) {
      if (!cache.current.tehsilGeoData[`tehsil_${state}`]) {
        try {
          const response = await fetch(
            `/geodata/tehsil?state=${encodeURIComponent(state)}`
          );
          console.log('preload status for', state, response.status);

          const text = await response.text();
          console.log('preload raw text for', state, text.substring(0, 300)); // first 300 chars

          if (!response.ok) {
            console.warn('preload non-OK response for', state);
            continue;
          }

          let data;
          try {
            data = JSON.parse(text);
          } catch (e) {
            console.error('preload JSON parse error for', state, e);
            continue;
          }

          console.log('preload parsed JSON for', state, data);
          cache.current.tehsilGeoData[`tehsil_${state}`] = data;
        } catch (error) {
          console.warn("Failed to preload data for:", state, error);
        }
      }
    }
  };


  useEffect(() => {
    setTimeout(() => {
      preloadFrequentStates();
    }, 2000);
  }, []);

  useEffect(() => {
    // Cache warming logic removed or handled internally
  }, []);

  const handlePolygonClick = (feature, layer, isKhasra = false) => {
    console.log("🖱️ [AllChart] handlePolygonClick triggered", {
      isKhasra,
      village: feature.properties.village || feature.properties.NAME,
    });

    if (isKhasraWMSActiveRef.current) {
      console.warn("🚫 Click ignored: Khasra WMS active");
      return;
    }

    // Always get LATEST params from Ref to avoid stale closure issues in Leaflet events
    const {
      startDate: currentStart,
      selectedDate: currentEnd,
      selectedState: currentState,
      selectedDistrict: currentDistrict,
      selectedTehsil: currentTehsil,
      selectedSeason: currentSeason,
      villageName: currentVillage,
    } = latestParamsRef.current;

    const clickedVillageName =
      feature.properties.village ||
      feature.properties.NAME ||
      feature.properties.Name;

    // Build finalStart/finalEnd with fallback defaults if needed
    let finalStart = currentStart;
    let finalEnd = currentEnd;

    if (!finalStart || !finalEnd) {
      console.warn("⚠️ Dates missing in Ref, attempting defaults...");
      if (currentState === "Rajasthan") {
        finalStart = "2024-11-01";
        finalEnd = "2025-04-15";
      } else if (currentState === "Maharashtra") {
        finalStart = "2023-11-15";
        finalEnd = "2024-04-15";
      } else {
        finalStart = "2024-11-01";
        finalEnd = "2025-04-15";
      }
      // Keep Redux consistent
      dispatch(setStartDate(finalStart));
      dispatch(setEndDate(finalEnd));
    }

    if (!finalStart || !finalEnd) {
      console.error("❌ Click failed: Could not determine dates.");
      alert("Please select a valid date range.");
      return;
    }

    // Helper: build a stable request key (season/year/dates/village) to compare
    const buildRequestKey = (season, start, end, village) =>
      `${season || "none"}::${start || "none"}::${end || "none"}::${(village || "").toString().trim().toLowerCase()}`;

    // If district/tehsil are missing in latestRef, read live Redux as fallback (Condition 2)
    if (!currentDistrict || !currentTehsil) {
      const liveState = store.getState();
      const liveDistrict = liveState.location.district;
      const liveTehsil = liveState.location.tehsil;
      const liveSeason = liveState.indices.selectedSeason;
      const liveStart = liveState.indices.startDate;
      const liveEnd = liveState.indices.endDate;
      const liveVillage = liveState.location.village;

      console.log("🔄 [Condition 2 Fallback] Ref was stale. Live Redux state:", {
        district: liveDistrict, tehsil: liveTehsil, season: liveSeason,
        startDate: liveStart, endDate: liveEnd,
      });

      if (!liveDistrict || !liveTehsil) {
        console.warn("⏳ District/Tehsil still loading, cannot fetch yet.");
        return;
      }

      // ✅ STRICT VALIDATION (Fallback): Check if a village is selected in Redux
      if (!liveVillage) {
        console.warn("🚫 [Condition 2] Click ignored: No village selected in Redux.");
        return;
      }

      // ✅ STRICT VALIDATION (Fallback): Check if clicked village matches Redux selection
      const isSameVillage = clickedVillageName?.toString().trim().toLowerCase() === liveVillage.toString().trim().toLowerCase();
      if (!isSameVillage) {
        console.warn("🚫 [Condition 2] Click ignored: Clicked village does not match Redux selection.");
        return;
      }

      const clickedVillage = liveVillage; // Always use selected village

      // Build keys to decide whether to re-fetch
      const currentRequestKey = buildRequestKey(liveSeason || currentSeason, liveStart || finalStart, liveEnd || finalEnd, clickedVillage);
      const lastKey = layer._lastRequestKey || null;

      // If already selected and params changed -> re-fetch instead of deselect
      if (layer.selected && lastKey && lastKey !== currentRequestKey) {
        console.log("🔁 [Condition 2] Selected polygon clicked with changed params -> re-fetching:", { lastKey, currentRequestKey });

        // Keep selected styling (do not toggle off)
        layer.setStyle({
          color: isKhasra ? "#4CAF50" : "#7C3AED",
          weight: 5,
          fillOpacity: 0.3,
          fillColor: isKhasra ? "#4CAF50" : "#7C3AED",
        });
        setSelectedPolygon(layer);
        layer.selected = true;

        layer.isRequestPending = true;
        const requestBody = {
          type: "Feature",
          geometry: feature.geometry,
          datetime: `${liveStart || finalStart}/${liveEnd || finalEnd}`,
          state: liveState.location.state,
          district: liveDistrict,
          tehsil: liveTehsil,
          season: liveSeason || currentSeason,
          village: clickedVillage,
        };

        // mark the request key before calling to avoid race
        layer._lastRequestKey = currentRequestKey;
        console.log("REQUEST_BODY_JSON:", JSON.stringify(requestBody));
        fetchPolygonNDVI(requestBody).finally(() => {
          if (layer) layer.isRequestPending = false;
        });

        mapInstanceRef.current.fitBounds(layer.getBounds(), { padding: [40, 40] });
        return;
      }

      // Normal select/deselect behavior for fallback branch
      if (!layer.selected) {
        console.log("🚀 [Condition 2] SELECTING via live state:", clickedVillage);
        layer.setStyle({
          color: isKhasra ? "#4CAF50" : "#7C3AED",
          weight: 5,
          fillOpacity: 0.3,
          fillColor: isKhasra ? "#4CAF50" : "#7C3AED",
        });
        setSelectedPolygon(layer);
        layer.selected = true;

        const requestBody = {
          type: "Feature",
          geometry: feature.geometry,
          datetime: `${liveStart || finalStart}/${liveEnd || finalEnd}`,
          state: liveState.location.state,
          district: liveDistrict,
          tehsil: liveTehsil,
          season: liveSeason || currentSeason,
          village: clickedVillage,
        };

        // set layer's last request key
        layer._lastRequestKey = buildRequestKey(liveSeason || currentSeason, liveStart || finalStart, liveEnd || finalEnd, clickedVillage);

        layer.isRequestPending = true;
        fetchPolygonNDVI(requestBody).finally(() => {
          if (layer) layer.isRequestPending = false;
        });

        mapInstanceRef.current.fitBounds(layer.getBounds(), { padding: [40, 40] });
      } else {
        console.log("🔄 DESELECTING village polygon (Condition 2)");
        layer.setStyle({
          color: "#F97316", weight: 1, fillOpacity: 0, fillColor: "transparent",
        });
        setSelectedPolygon(null);
        layer.selected = false;
      }
      return; // handled in fallback branch
    }

    // ---------- From here we have valid currentDistrict & currentTehsil ----------
    // ✅ STRICT VALIDATION: Check if a village is selected in Ref
    if (!currentVillage) {
      console.warn("🚫 Click ignored: No village selected in dropdown.");
      return;
    }

    // ✅ STRICT VALIDATION: Check if clicked village matches Ref selection
    const isSameVillage = clickedVillageName?.toString().trim().toLowerCase() === currentVillage.toString().trim().toLowerCase();
    if (!isSameVillage) {
      console.warn("🚫 Click ignored: Clicked village does not match selected village.");
      return;
    }

    // Build current request key from latestParamsRef (these are the authoritative values for this branch)
    const currentRequestKey = buildRequestKey(currentSeason, finalStart, finalEnd, clickedVillageName || currentVillage);
    const lastRequestKey = layer._lastRequestKey || null;

    // If layer already selected AND the request params (season/dates) changed compared to last request key => re-fetch
    if (layer.selected && lastRequestKey && lastRequestKey !== currentRequestKey) {
      console.log("🔁 Selected polygon clicked with changed params -> re-fetching:", { lastRequestKey, currentRequestKey });

      // keep it selected and re-fetch
      layer.setStyle({
        color: isKhasra ? "#4CAF50" : "#7C3AED",
        weight: 5,
        fillOpacity: 0.3,
        fillColor: isKhasra ? "#4CAF50" : "#7C3AED",
      });
      setSelectedPolygon(layer);
      layer.selected = true;

      const requestBody = {
        type: "Feature",
        geometry: feature.geometry,
        datetime: `${finalStart}/${finalEnd}`,
        state: currentState,
        district: currentDistrict,
        tehsil: currentTehsil,
        season: currentSeason,
        village: clickedVillageName || currentVillage,
      };

      // mark layer's last request key BEFORE calling
      layer._lastRequestKey = currentRequestKey;

      layer.isRequestPending = true;
      fetchPolygonNDVI(requestBody).finally(() => {
        if (layer) layer.isRequestPending = false;
      });

      mapInstanceRef.current.fitBounds(layer.getBounds(), {
        padding: [40, 40],
      });

      return; // done
    }

    // Normal selection path (not re-fetch condition)
    if (!layer.selected) {
      console.log(
        "🚀 SELECTING: Fetching data for",
        clickedVillageName || currentVillage
      );

      // Styling: Consistent with manual physical click (Violet for Village, Green for Khasra)
      layer.setStyle({
        color: isKhasra ? "#4CAF50" : "#7C3AED",
        weight: 5,
        fillOpacity: 0.3,
        fillColor: isKhasra ? "#4CAF50" : "#7C3AED",
      });

      setSelectedPolygon(layer);
      layer.selected = true;

      const requestBody = {
        type: "Feature",
        geometry: feature.geometry,
        datetime: `${finalStart}/${finalEnd}`,
        state: currentState,
        district: currentDistrict,
        tehsil: currentTehsil,
        season: currentSeason,
        village: clickedVillageName || currentVillage,
      };

      // Save the last request key so future clicks can detect changes
      layer._lastRequestKey = currentRequestKey;

      layer.isRequestPending = true;
      fetchPolygonNDVI(requestBody).finally(() => {
        if (layer) layer.isRequestPending = false;
      });

      // Auto-zoom/pan to ensure it's centered when clicked
      mapInstanceRef.current.fitBounds(layer.getBounds(), {
        padding: [40, 40],
      });
    } else {
      // If already selected and params unchanged — keep original deselect behavior
      console.log("🔄 DESELECTING village polygon");
      layer.setStyle({
        color: isSameVillage ? "#7C3AED" : "#F97316",
        weight: isSameVillage ? 3 : 1,
        fillOpacity: isSameVillage ? 0.15 : 0,
        fillColor: isSameVillage ? "#7C3AED" : "transparent",
      });
      setSelectedPolygon(null);
      layer.selected = false;
    }
  };


  const delay = (ms) => new Promise((res) => setTimeout(res, ms));

  const fetchPolygonNDVI = async (requestBody) => {
    
    setLoading(true);
    setProgress(0);
    console.log("REQUEST_BODY_JSON:", JSON.stringify(requestBody));
    try {
      const response = await fetch("/api/calculate_all_indices", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      console.log("📡 API Response Status:", response.status);
      setProgress(10);
      await delay(200);

      const text = await response.text();
      console.log("💾 API Raw Response Preview:", text.substring(0, 200));

      if (!response.ok) {
        throw new Error(`API error: ${response.status} - ${text}`);
      }

      const data = JSON.parse(text);
      console.log("✅ API JSON Parsed. Keys:", Object.keys(data));
      setProgress(50);
      await delay(500);

      if (data && data.ndvi_data && Object.keys(data.ndvi_data).length > 0) {
        console.log("📊 Updating charts and weather data...");

        // Store bbox for overlay placement
        if (data.bbox) {
          window._lastNdviBbox = data.bbox;
        }

        // Handle weather compression
        if (data.weather_data && data.weather_data.all_weather_data) {
          const compressedWeather = LZString.compress(
            JSON.stringify(data.weather_data.all_weather_data || [])
          );
          sessionStorage.setItem("weatherData", compressedWeather);
          setWeatherData(data.weather_data.all_weather_data);
        }

        updateNDVIChart(data.ndvi_data);
        setProgress(100);
      } else {
        console.warn("⚠️ API returned no ndvi_data or empty object:", data);
        dispatch(
          setChartData({
            NDVI: { labels: [], values: [], images: [], activePoints: [] },
            NDMI: { labels: [], values: [], images: [], activePoints: [] },
            EVI: { labels: [], values: [], images: [], activePoints: [] },
            SVHI: { labels: [], values: [], images: [], activePoints: [] },
            TrueColor: { images: [] },
          })
        );
        setProgress(100);
      }
    } catch (error) {
      console.error("❌ [fetchPolygonNDVI] Error:", error);
      alert("Error fetching data. Check console for details.");
    } finally {
      await delay(500);
      setLoading(false);
      setProgress(0);
    }
  };

  const indexLegend = {
    NDVI: [
      {
        range: "0.0 - 0.1",
        label: "No Vegetation / Built-up",
        color: "#d73027",
      },
      { range: "0.1 - 0.2", label: "Bare Soil", color: "#fdae61" },
      { range: "0.2 - 0.3", label: "Sparse Vegetation", color: "#a6d96a" },
      { range: "0.3 - 0.8", label: "Moderate Vegetation", color: "#1a9850" },
    ],
    NDMI: [
      { range: "0.0 - 0.05", label: "Dry", color: "#f7fbff" },
      { range: "0.05 - 0.10", label: "Low Moisture", color: "#deebf7" },
      { range: "0.10 - 0.15", label: "Moderate Moisture", color: "#9ecae1" },
      { range: "0.15 - 0.20", label: "High Moisture", color: "#3182bd" },
    ],
    EVI: [
      { range: "0.0 - 0.1", label: "Bare Soil / Low Veg", color: "#ffffcc" },
      { range: "0.1 - 0.2", label: "Moderate Vegetation", color: "#a1dab4" },
      { range: "0.2 - 0.25", label: "Dense Vegetation", color: "#41b6c4" },
      { range: "0.25 - 0.6", label: "Very Dense Vegetation", color: "#225ea8" },
    ],
    SVHI: [
      { range: "0.0 - 0.2", label: "Poor Vegetation Health", color: "#d73027" },
      { range: "0.2 - 0.4", label: "Moderate Vegetation Health", color: "#f46d43" },
      { range: "0.4 - 0.6", label: "Good Vegetation Health", color: "#fdae61" },
      { range: "0.6 - 1.0", label: "Excellent Vegetation Health", color: "#fee08b" },
    ],
  };

  const indexFormulas = {
    NDVI: "(NIR - Red) / (NIR + Red)",
    NDMI: "(NIR - SWIR) / (NIR + SWIR)",
    EVI: "2.5 * (NIR - Red) / (NIR + 6*Red - 7.5*Blue + 1)",
    SVHI: "0.5 * (NDVI + NDMI) - 0.5",
  };

  // Updated renderLegend function for AllChart.js with DEM view styling
  const renderLegend = () => {
    return (
      <div
        key={`legend-${forceRender}`}
        className="legend-wrapper"
        style={{
          overflowY: "auto",
          padding: "5px",
          borderRadius: "8px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          // Updated background to match DEM view - dark theme
          backgroundColor: "#212529",
          position: "relative",
          width: "160px",
          maxHeight: "220px",
          marginRight: "0px",
          fontFamily: "Arial, sans-serif",
        }}
      >
        <button
          onClick={toggleLegendInfo}
          style={{
            position: "absolute",
            top: "9px",
            right: "5px",
            cursor: "pointer",
            border: "none",
            background: "none",
            fontSize: "15px",
            // White text for dark background
            color: "white",
          }}
        >
          ℹ️
        </button>

        {showInfo.current ? (
          <div
            style={{
              textAlign: "center",
              fontSize: "14px",
              // White text for dark background
              color: "white",
            }}
          >
            <h4
              style={{
                color: "white",
                margin: "0 0 8px 0",
                fontSize: "12px",
              }}
            >
              Index Calculation Formulas
            </h4>
            {Object.entries(indexFormulas).map(([index, formula]) => (
              <p key={index} style={{ color: "white", fontSize: "11px" }}>
                <strong>{index}:</strong> {formula}
              </p>
            ))}
            <button
              onClick={toggleLegendInfo}
              style={{
                marginTop: "10px",
                padding: "5px 10px",
                backgroundColor: "#007BFF",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              Back to Legend
            </button>
          </div>
        ) : (
          <>
            {selectedIndices?.length > 0 ? (
              selectedIndices.map((index) => (
                <div
                  key={index}
                  style={{
                    marginBottom: "10px",
                    // Dark border for dark theme
                    border: "1px solid #495057",
                    borderRadius: "8px",
                    padding: "5px",
                  }}
                >
                  <h4
                    style={{
                      fontSize: "12px",
                      marginBottom: "8px",
                      textAlign: "center",
                      // White text for dark background
                      color: "white",
                      fontWeight: "bold",
                    }}
                  >
                    {index} Legend
                  </h4>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "6px",
                    }}
                  >
                    {indexLegend[index]?.map((item, idx) => (
                      <div
                        key={idx}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          // Dark background for legend items
                          backgroundColor: "#343a40",
                          padding: "4px 8px",
                          borderRadius: "4px",
                          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
                        }}
                      >
                        <div
                          style={{
                            width: "18px",
                            height: "10px",
                            backgroundColor: item.color,
                            border: "1px solid #6c757d",
                            marginRight: "6px",
                          }}
                        ></div>
                        <span
                          style={{
                            fontSize: "11px",
                            // White text for dark background
                            color: "white",
                          }}
                        >
                          {item.range}: {item.label}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              ))
            ) : (
              <p
                style={{
                  textAlign: "center",
                  // Light gray text for "no data" message
                  color: "#adb5bd",
                }}
              >
                No legend data available
              </p>
            )}
          </>
        )}
      </div>
    );
  };

  const updateNDVIChart = (data) => {
    if (data && Array.isArray(data.images)) {
      // Get all unique actual dates from the satellite data

      const actualDates = [
        ...new Set(data.images.map((img) => img.date)),
      ].sort();
      if (actualDates.length === 0) {
        console.error("No dates found in the data");
        dispatch(setChartData({
          NDVI: { labels: [], values: [], images: [], activePoints: [] },
          NDMI: { labels: [], values: [], images: [], activePoints: [] },
          EVI: { labels: [], values: [], images: [], activePoints: [] },
          SVHI: { labels: [], values: [], images: [], activePoints: [] },
          TrueColor: { images: [] },
        }));
        return;
      }

      console.log("Available satellite dates:", actualDates);

      // Debug: Check what's in the data.images array
      console.log("Sample data.images entries:");
      data.images.slice(0, 3).forEach((img) => {
        console.log(
          `  Date: ${img.date}, Index: ${img.index}, Value: ${img.mean_value}`
        );
      });

      // Generate complete timeline starting from first available image
      const firstAvailableDate = new Date(actualDates[0]);
      const lastAvailableDate = new Date(actualDates[actualDates.length - 1]);

      console.log(`First available image: ${actualDates[0]}`);
      console.log(
        `Last available image: ${actualDates[actualDates.length - 1]}`
      );

      // Calculate the satellite pass pattern based on actual data
      // Find the most common interval between consecutive dates
      const intervals = [];
      for (let i = 1; i < actualDates.length; i++) {
        const date1 = new Date(actualDates[i - 1]);
        const date2 = new Date(actualDates[i]);
        const daysDiff = Math.round((date2 - date1) / (1000 * 60 * 60 * 24));
        if (daysDiff > 0 && daysDiff <= 10) {
          // Reasonable satellite interval
          intervals.push(daysDiff);
        }
      }

      // Default to 5 days if we can't determine pattern
      const satelliteInterval =
        intervals.length > 0
          ? Math.round(intervals.reduce((a, b) => a + b) / intervals.length)
          : 5;

      console.log(`Detected satellite interval: ${satelliteInterval} days`);

      const completeTimeline = [];
      const currentDate = new Date(firstAvailableDate);

      // Generate timeline based on the detected interval
      while (currentDate <= lastAvailableDate) {
        completeTimeline.push(currentDate.toISOString().split("T")[0]);
        currentDate.setDate(currentDate.getDate() + satelliteInterval);
      }

      // Also include any actual dates that don't fall exactly on the interval
      actualDates.forEach((date) => {
        if (!completeTimeline.includes(date)) {
          completeTimeline.push(date);
        }
      });

      // Sort the final timeline
      completeTimeline.sort();

      console.log(
        `Generated timeline: ${completeTimeline.length} dates from ${completeTimeline[0]
        } to ${completeTimeline[completeTimeline.length - 1]}`
      );
      console.log(
        `Timeline starts from first available image, not user's start date`
      );

      // Create a map for quick lookup of actual data
      const dataMap = new Map();
      data.images.forEach((img) => {
        const key = `${img.date}_${img.index}`;
        const parsedValue = parseFloat(img.mean_value);
        dataMap.set(key, {
          ...img,
          mean_value: isNaN(parsedValue) ? null : parsedValue, // convert string to float safely
        });
      });

      // Process each index with the complete timeline
      const processedData = {};

      ["NDVI", "NDMI", "EVI", "SVHI"].forEach((index) => {
        const values = [];
        const images = [];
        const activePoints = [];
        const labels = [];

        completeTimeline.forEach((dateStr, i) => {
          const key = `${dateStr}_${index}`;
          const actualData = dataMap.get(key);

          labels.push(dateStr);

          // Check if this date exists in our actual satellite dates
          const hasActualData =
            actualDates.includes(dateStr) &&
            actualData &&
            !isNaN(parseFloat(actualData.mean_value));

          if (hasActualData) {
            // We have actual satellite data for this date
            values.push(parseFloat(actualData.mean_value));
            images.push(actualData);
            activePoints.push(true); // Actual data point

            console.log(
              `✅ ${dateStr}: ${parseFloat(actualData.mean_value).toFixed(
                3
              )} (${index}) - ACTUAL DATA`
            );
          } else {
            // Missing data - need to interpolate
            const interpolatedValue = interpolateValue(
              completeTimeline,
              i,
              index,
              dataMap
            );

            values.push(interpolatedValue);
            images.push({
              date: dateStr,
              image_url: null,
              index: index,
              mean_value: interpolatedValue,
              interpolated: true, // Mark as interpolated
            });
            activePoints.push(false); // Interpolated data point

            console.log(
              `📈 ${dateStr}: ${interpolatedValue.toFixed(
                3
              )} (${index}) - INTERPOLATED (Cloud Cover)`
            );
          }
        });

        processedData[index] = {
          labels: labels,
          values: values,
          images: images,
          activePoints: activePoints,
        };

        // Log statistics
        const actualCount = activePoints.filter((a) => a).length;
        const interpolatedCount = activePoints.filter((a) => !a).length;
        console.log(`${index} Statistics:`);
        console.log(
          `  - Total points: ${labels.length}`);
        console.log(
          `  - Actual data: ${actualCount} (${Math.round(
            (actualCount / labels.length) * 100
          )}%)`
        );
        console.log(
          `  - Interpolated: ${interpolatedCount} (${Math.round(
            (interpolatedCount / labels.length) * 100
          )}%)`
        );
      });

      // Handle TrueColor separately - include all dates but mark which have actual images
      const trueColorImages = completeTimeline.map((dateStr) => {
        const key = `${dateStr}_TrueColor`;
        const actualData = dataMap.get(key);

        if (actualData) {
          return actualData;
        } else {
          return {
            date: dateStr,
            image_url: null,
            index: "TrueColor",
            interpolated: true,
          };
        }
      });

      dispatch(setChartData({
        NDVI: processedData.NDVI,
        NDMI: processedData.NDMI,
        EVI: processedData.EVI,
        SVHI: processedData.SVHI,
        TrueColor: { images: trueColorImages },
      }));
      setSeasonalScores(computeSeasonalScores(processedData));

      console.log(
        "📊 Chart updated with complete timeline including interpolated values"
      );
    } else {
      console.error("Invalid NDVI data structure:", data);
      dispatch(setChartData({
        NDVI: { labels: [], values: [], images: [], activePoints: [] },
        NDMI: { labels: [], values: [], images: [], activePoints: [] },
        EVI: { labels: [], values: [], images: [], activePoints: [] },
        SVHI: { labels: [], values: [], images: [], activePoints: [] },
        TrueColor: { images: [] },
      }));
    }
  };

  // Enhanced interpolation function that properly follows trends
  const interpolateValue = (
    timeline,
    currentIndex,
    indexType,
    dataMap,
    allData
  ) => {
    console.log(
      `🔍 Interpolating ${indexType} at index ${currentIndex} (${timeline[currentIndex]})`
    );

    // Extract all actual values for this index type
    const actualValues = [];
    for (let i = 0; i < timeline.length; i++) {
      const dateStr = timeline[i];
      const key = `${dateStr}_${indexType}`;
      const data = dataMap.get(key);

      if (
        data &&
        typeof data.mean_value === "number" &&
        !isNaN(data.mean_value)
      ) {
        actualValues.push({
          index: i,
          date: dateStr,
          value: data.mean_value,
        });
      }
    }

    console.log(
      `📊 Found ${actualValues.length} actual values for ${indexType}`
    );

    // If no actual values at all, use seasonal default
    if (actualValues.length === 0) {
      console.log(`⚠️ No actual values found, using seasonal default`);
      return getSeasonalDefault(indexType);
    }

    // Find nearest previous and next actual values
    let prevPoint = null;
    let nextPoint = null;

    // Look for previous actual value
    for (let i = actualValues.length - 1; i >= 0; i--) {
      if (actualValues[i].index < currentIndex) {
        prevPoint = actualValues[i];
        break;
      }
    }

    // Look for next actual value
    for (let i = 0; i < actualValues.length; i++) {
      if (actualValues[i].index > currentIndex) {
        nextPoint = actualValues[i];
        break;
      }
    }

    console.log(
      `📍 Prev point: ${prevPoint ? `${prevPoint.date} (${prevPoint.value})` : "none"
      }`
    );
    console.log(
      `📍 Next point: ${nextPoint ? `${nextPoint.date} (${nextPoint.value})` : "none"
      }`
    );

    // Case 1: Both previous and next values exist - linear interpolation
    if (prevPoint && nextPoint) {
      const totalDistance = nextPoint.index - prevPoint.index;
      const currentDistance = currentIndex - prevPoint.index;
      const ratio = currentDistance / totalDistance;

      // Linear interpolation with trend consideration
      const interpolated =
        prevPoint.value + (nextPoint.value - prevPoint.value) * ratio;

      console.log(
        `📈 Linear interpolation: ${prevPoint.value.toFixed(
          3
        )} -> ${interpolated.toFixed(3)} -> ${nextPoint.value.toFixed(3)}`
      );

      return Math.round(interpolated * 1000) / 1000;
    }

    // Case 2: Only previous values exist - use trend extrapolation
    if (prevPoint && !nextPoint) {
      // Find at least 2 previous points to establish trend
      const prevPoints = actualValues
        .filter((p) => p.index <= currentIndex)
        .slice(-3);

      if (prevPoints.length >= 2) {
        // Calculate trend from last 2-3 points
        const trendPoints = prevPoints.slice(-2);
        const slope =
          (trendPoints[1].value - trendPoints[0].value) /
          (trendPoints[1].index - trendPoints[0].index);
        const distanceFromLast = currentIndex - trendPoints[1].index;

        // Extrapolate with damping to prevent extreme values
        const dampingFactor = Math.exp(-distanceFromLast * 0.1); // Exponential damping
        const extrapolated =
          trendPoints[1].value + slope * distanceFromLast * dampingFactor;

        // Ensure value stays within reasonable bounds
        const minBound = Math.min(...actualValues.map((p) => p.value)) * 0.8;
        const maxBound = Math.max(...actualValues.map((p) => p.value)) * 1.2;

        const bounded = Math.max(minBound, Math.min(maxBound, extrapolated));

        console.log(
          `📉 Trend extrapolation: slope=${slope.toFixed(
            4
          )}, result=${bounded.toFixed(3)}`
        );

        return Math.round(bounded * 1000) / 1000;
      } else {
        // Only one previous point, use it with slight decay
        const distanceFromLast = currentIndex - prevPoint.index;
        const decayFactor = Math.exp(-distanceFromLast * 0.05);
        const decayed = prevPoint.value * (0.9 + 0.1 * decayFactor);

        console.log(
          `📉 Single point decay: ${prevPoint.value.toFixed(
            3
          )} -> ${decayed.toFixed(3)}`
        );

        return Math.round(decayed * 1000) / 1000;
      }
    }

    // Case 3: Only next values exist - use future trend
    if (!prevPoint && nextPoint) {
      // Find at least 2 next points to establish trend
      const nextPoints = actualValues
        .filter((p) => p.index >= currentIndex)
        .slice(0, 3);

      if (nextPoints.length >= 2) {
        // Calculate trend from first 2-3 points
        const trendPoints = nextPoints.slice(0, 2);
        const slope =
          (trendPoints[1].value - trendPoints[0].value) /
          (trendPoints[1].index - trendPoints[0].index);
        const distanceFromFirst = trendPoints[0].index - currentIndex;

        // Extrapolate backwards with damping
        const dampingFactor = Math.exp(-distanceFromFirst * 0.1);
        const extrapolated =
          trendPoints[0].value - slope * distanceFromFirst * dampingFactor;

        // Ensure value stays within reasonable bounds
        const minBound = Math.min(...actualValues.map((p) => p.value)) * 0.8;
        const maxBound = Math.max(...actualValues.map((p) => p.value)) * 1.2;

        const bounded = Math.max(minBound, Math.min(maxBound, extrapolated));

        console.log(
          `📈 Backward extrapolation: slope=${slope.toFixed(
            4
          )}, result=${bounded.toFixed(3)}`
        );

        return Math.round(bounded * 1000) / 1000;
      } else {
        // Only one next point, use it with slight adjustment
        const distanceToNext = nextPoint.index - currentIndex;
        const adjustFactor = Math.exp(-distanceToNext * 0.05);
        const adjusted = nextPoint.value * (0.9 + 0.1 * adjustFactor);

        console.log(
          `📈 Single point adjustment: ${nextPoint.value.toFixed(
            3
          )} -> ${adjusted.toFixed(3)}`
        );

        return Math.round(adjusted * 1000) / 1000;
      }
    }

    // Case 4: Should not reach here, but if it does, use weighted average
    const avgValue =
      actualValues.reduce((sum, p) => sum + p.value, 0) / actualValues.length;
    console.log(`⚠️ Fallback to average: ${avgValue.toFixed(3)}`);

    return Math.round(avgValue * 1000) / 1000;
  };

  // Improved seasonal default function with more realistic values
  const getSeasonalDefault = (indexType) => {
    // These should be based on your specific region and crop type
    const seasonalDefaults = {
      NDVI: 0.35, // Moderate vegetation (typical agricultural land)
      NDMI: 0.12, // Moderate moisture (neither too dry nor too wet)
      EVI: 0.2, // Moderate enhanced vegetation
      SVHI: 0.25, // Seasonal Vegetation Health Index (default)
    };

    const defaultValue = seasonalDefaults[indexType] || 0.25;
    console.log(`📊 Using seasonal default for ${indexType}: ${defaultValue}`);
    return defaultValue;
  };

  // Helper function to smooth the interpolated values (optional post-processing)
  const smoothInterpolatedValues = (values, activePoints) => {
    const smoothed = [...values];

    // Apply a simple moving average to interpolated values only
    for (let i = 1; i < values.length - 1; i++) {
      if (!activePoints[i]) {
        // Only smooth interpolated values
        const prevValue = values[i - 1];
        const currentValue = values[i];
        const nextValue = values[i + 1];

        // Simple 3-point moving average
        smoothed[i] = (prevValue + currentValue + nextValue) / 3;

        // Round to 3 decimal places
        smoothed[i] = Math.round(smoothed[i] * 1000) / 1000;
      }
    }

    return smoothed;
  };
  const generateSatelliteTimeline = (actualDates) => {
    if (actualDates.length === 0) return [];

    // Start from the first actual satellite pass
    const firstDate = new Date(actualDates[0]);
    const lastDate = new Date(actualDates[actualDates.length - 1]);

    console.log(
      `Generating timeline from first satellite pass: ${firstDate.toISOString().split("T")[0]
      } to ${lastDate.toISOString().split("T")[0]}`
    );

    const timeline = [];
    const currentDate = new Date(firstDate);

    // Generate 5-day intervals from first actual satellite pass
    while (currentDate <= lastDate) {
      timeline.push(currentDate.toISOString().split("T")[0]);
      currentDate.setDate(currentDate.getDate() + 5); // Sentinel-2 revisit cycle
    }

    // Also include any actual dates that don't fall on the exact 5-day pattern
    // This handles cases where satellite timing might be slightly off
    actualDates.forEach((date) => {
      if (!timeline.includes(date)) {
        timeline.push(date);
      }
    });

    // Sort the final timeline
    timeline.sort();

    console.log(`Generated ${timeline.length} expected satellite passes`);
    return timeline;
  };

  const showCloudCoverNotification = (date) => {
    // Create a popup or notification
    const popup = L.popup()
      .setLatLng(mapInstanceRef.current.getCenter())
      .setContent(
        `
      <div style="text-align: center; padding: 10px;">
        <h4 style="margin: 0 0 10px 0;">Cloud Cover Detected</h4>
        <p style="margin: 5px 0;">No satellite imagery available for ${date}</p>
        <p style="margin: 5px 0; font-size: 12px; color: #666;">
          Due to cloud cover, satellite data could not be captured on this date.
          The displayed value is interpolated from nearby dates.
        </p>
      </div>
    `
      )
      .openOn(mapInstanceRef.current);
  };

  function computeSeasonalScores(chartData) {
    const indices = ["NDVI", "NDMI", "EVI", "SVHI"];
    const scores = {};

    indices.forEach((index) => {
      const data = chartData[index];
      if (!data || !Array.isArray(data.images)) return;

      const actualReadings = data.images.filter(
        (img) => !img.interpolated && img.mean_value !== null
      );
      if (actualReadings.length === 0) return;

      const values = actualReadings
        .map((img) => parseFloat(img.mean_value))
        .filter((val) => !isNaN(val));

      const sum = values.reduce((a, b) => a + b, 0);
      const avg = (sum / values.length) * 100; // scaled to 100 (if needed)
      const min = Math.min(...values) * 100;
      const max = Math.max(...values) * 100;

      scores[index] = {
        average_score: avg,
        min_value: min,
        max_value: max,
        total_readings: values.length,
        health_category: getHealthCategory(index, avg),
      };
    });

    return scores;
  }

  function getHealthCategory(index, avgScore) {
    if (index === "NDVI") {
      if (avgScore >= 70) return "Excellent";
      if (avgScore >= 50) return "Good";
      if (avgScore >= 30) return "Fair";
      if (avgScore >= 10) return "Poor";
      return "Very Poor";
    }
    if (index === "NDMI") {
      if (avgScore >= 40) return "High Moisture";
      if (avgScore >= 30) return "Moderate Moisture";
      if (avgScore >= 20) return "Low Moisture";
      return "Dry";
    }
    if (index === "EVI") {
      if (avgScore >= 60) return "Very Dense";
      if (avgScore >= 45) return "Dense";
      if (avgScore >= 30) return "Moderate";
      if (avgScore >= 15) return "Sparse";
      return "Very Sparse";
    }
    if (index === "SVHI") {
      if (avgScore >= 70) return "Excellent Health";
      if (avgScore >= 50) return "Good Health";
      if (avgScore >= 30) return "Fair Health";
      if (avgScore >= 10) return "Poor Health";
      return "Very Poor Health";
    }
    return "No Data";
  }

  const handleSearch = async () => {
    console.log("🔍 [AllChart] Physical Search triggered for", villageName);

    // If we have a village selected in dropdown, find its layer and trigger click logic
    if (villageName && currentVillageLayerRef.current) {
      const layers = currentVillageLayerRef.current.getLayers();
      const selectedLayer = layers.find(l => {
        const f = l.feature;
        const pName = f.properties.village || f.properties.NAME || f.properties.Name;
        return pName?.toString().trim().toLowerCase() === villageName.toString().trim().toLowerCase();
      });

      if (selectedLayer) {
        console.log("🎯 Triggering click handler for found layer:", villageName);
        handlePolygonClick(selectedLayer.feature, selectedLayer, false);
      } else {
        console.warn("⚠️ Could not find map layer for village:", villageName);
      }
    } else {
      console.warn("⚠️ Cannot search: No village selected or map layer not ready.");
    }
  };

  // ✅ Auto-search and legacy handleSearch logic removed.

  const handleKhasraNumberChange = (event) => {
    setKhasraNumber(event.target.value);
  };

  const handleToggle = () => {
    setIsKhasraSearchEnabled(!isKhasraSearchEnabled);
  };

  // ============================================================
  // ✅ KHASRA — Full port from DEMView.js
  // ============================================================

  // 1. Click handler: map click → WMS GetFeatureInfo → highlight + popup
  const setupKhasraClickHandler = (map, khasraLayer, khasraVillageName, khasraTehsil) => {
    map.off("click");

    map.on("click", async (e) => {
      if (!khasraLayer || !map) return;

      console.log("🖱️ Khasra click detected");

      // ✅ STRICT CHECK: Only process click if inside the current Village Layer (Ref)
      if (currentVillageLayerRef.current) {
        let isInside = false;
        const clickedLat = e.latlng.lat;
        const clickedLng = e.latlng.lng;

        currentVillageLayerRef.current.eachLayer((layer) => {
          if (isInside) return;
          if (layer.feature && layer.feature.geometry) {
            if (isInsideGeoJSON && isInsideGeoJSON(clickedLat, clickedLng, layer.feature.geometry)) {
              isInside = true;
            }
          }
        });

        if (!isInside) {
          console.log("🚫 Click outside village boundary. Ignoring API call.");
          return;
        }
      }

      const mapContainer = map.getContainer();
      mapContainer.style.cursor = "wait";

      const { lat, lng } = e.latlng;
      const layerName = khasraLayer.wmsParams.layers;

      let cqlFilter = `state='${selectedState}' AND district='${selectedDistrict}' AND tehsil='${khasraTehsil}'`;
      if (khasraVillageName) {
        cqlFilter += ` AND village='${khasraVillageName}'`;
      }

      const point = map.latLngToContainerPoint(e.latlng);
      const size = map.getSize();

      const wmsUrl =
        `${GEO_SERVER_BASE_URL}/wms?service=WMS&version=1.1.1&request=GetFeatureInfo` +
        `&layers=${layerName}&query_layers=${layerName}` +
        `&info_format=application/json` +
        `&x=${Math.floor(point.x)}&y=${Math.floor(point.y)}` +
        `&height=${size.y}&width=${size.x}` +
        `&srs=EPSG:4326&bbox=${map.getBounds().toBBoxString()}` +
        `&cql_filter=${encodeURIComponent(cqlFilter)}`;

      try {
        const response = await fetch(wmsUrl);
        const data = await response.json();

        if (!data.features || data.features.length === 0) {
          console.warn("❌ No feature returned from WMS click.");
          mapContainer.style.cursor = "";
          return;
        }

        const feature = data.features[0];
        const props = feature.properties;

        const tableFields = [
          { name: "clicked_lat", header: "Latitude" },
          { name: "clicked_lng", header: "Longitude" },
          { name: "state", header: "State" },
          { name: "district", header: "District" },
          { name: "tehsil", header: "Tehsil" },
          { name: "village", header: "Village" },
          { name: "khasra_no", header: "Khasra No" },
          { name: "area_ac", header: "Area (Ac)" },
          { name: "lu_lc", header: "LU/LC" },
        ];

        let tableHtml = `<table class="popup-table"><thead></thead><tbody>`;
        tableFields.forEach((f) => {
          let value =
            f.name === "clicked_lat"
              ? lat.toFixed(6)
              : f.name === "clicked_lng"
                ? lng.toFixed(6)
                : props[f.name] ?? "N/A";
          tableHtml += `<tr><td><strong>${f.header}</strong></td><td>${value}</td></tr>`;
        });
        tableHtml += `<tr><td colspan="2" style="text-align:center;font-style:italic;color:#666;padding-top:8px;border-top:1px solid #ddd;">
          <small>Source: Land Revenue Department</small>
        </td></tr>`;
        tableHtml += `</tbody></table>`;

        if (khasraHighlightRef.current) {
          map.removeLayer(khasraHighlightRef.current);
          khasraHighlightRef.current = null;
        }

        const highlight = L.geoJSON(feature.geometry, {
          style: { color: "red", weight: 2, fillOpacity: 0.2 },
          onEachFeature: (f, layer) => {
            layer.bindPopup(tableHtml).openPopup();
          },
        }).addTo(map);

        khasraHighlightRef.current = highlight;
        console.log("✅ Khasra feature highlighted");

      } catch (err) {
        console.error("Khasra click fetch failed:", err);
      } finally {
        mapContainer.style.cursor = "";
      }
    });

    console.log("✅ Khasra click handler setup complete");
  };

  // 2. Toggle: show/hide Khasra WMS layer with loading states + tile error handling
  const handleKhasraToggle = async () => {
    try {
      setProgress(20);

      if (!selectedTehsil || !selectedState || !selectedDistrict) {
        console.error("Missing input for Khasra layer filter.");
        setProgress(0);
        return;
      }

      const map = mapInstanceRef.current;

      // HIDE: if already visible
      if (isKhasraVisible) {
        if (currentKhasraLayerRef.current) {
          map.removeLayer(currentKhasraLayerRef.current);
          currentKhasraLayerRef.current = null;
        }

        if (khasraHighlightRef.current) {
          map.removeLayer(khasraHighlightRef.current);
          khasraHighlightRef.current = null;
        }

        map.off("click");
        isKhasraWMSActiveRef.current = false;
        setIsKhasraVisible(false);
        setProgress(0);
        console.log("✅ Khasra layer hidden and click handler removed");
        return;
      }

      setProgress(40);

      // Layer name by state
      const layerMap = {
        Rajasthan: "ne:Rajasthan_Khasra_All1",
        Maharashtra: "ne:MH_Khasra_All",
        "Uttar Pradesh": "ne:UP_Khasra_All",
        "Andhra Pradesh": "ne:AP_Khasra_All",
        Karnataka: "ne:Karnataka_KHASRA_ALL",
      };
      const khasraLayerName = layerMap[selectedState];
      if (!khasraLayerName) {
        alert("No Khasra layer configured for this state.");
        setProgress(0);
        return;
      }

      setProgress(60);

      let cqlFilter = `state='${selectedState}' AND district='${selectedDistrict}' AND tehsil='${selectedTehsil}'`;

      // Use Redux villageName to match DEMView behavior (which supports WMS casing correctly)
      if (villageName) {
        cqlFilter += ` AND village='${villageName}'`;
        console.log(`🎯 Village-level Khasra filter: ${cqlFilter}`);
      } else {
        console.log(`🏘️ Tehsil-level Khasra filter: ${cqlFilter}`);
      }

      // Create khasra pane
      if (!map.getPane("khasraPane")) {
        map.createPane("khasraPane");
        map.getPane("khasraPane").style.zIndex = 550;
      }

      const khasraLayer = L.tileLayer.wms(
        `${GEO_SERVER_BASE_URL}/wms`,
        {
          layers: khasraLayerName,
          format: "image/png",
          transparent: true,
          version: "1.1.0",
          attribution: "Land Revenue Department",
          pane: "khasraPane",
          zIndex: 550,
          CQL_FILTER: cqlFilter,
          tiled: true,
        }
      );

      khasraLayer.on("loading", () => {
        setProgress(80);
      });

      khasraLayer.on("load", () => {
        setProgress(100);
        setTimeout(() => setProgress(0), 400);
      });

      khasraLayer.on("tileerror", (error) => {
        console.error("Khasra layer loading error:", error);
        setProgress(0);

        if (!hasShownKhasraTileErrorRef.current) {
          alert("Failed to load Khasra layer. Please try again.");
          hasShownKhasraTileErrorRef.current = true;
          setTimeout(() => {
            hasShownKhasraTileErrorRef.current = false;
          }, 10000);
        }
      });

      khasraLayer.addTo(map);
      currentKhasraLayerRef.current = khasraLayer;
      isKhasraWMSActiveRef.current = true;
      setIsKhasraVisible(true);

      // Setup click handler AFTER layer is added
      setupKhasraClickHandler(map, khasraLayer, villageName, selectedTehsil);

      console.log("✅ Khasra layer shown and click handler activated");
      setTimeout(() => ensureKhasraOnTop(), 100);

    } catch (err) {
      console.error("Failed to toggle Khasra:", err);
      setProgress(0);
    }
  };

  // ✅ Fix Khasra Layer Scope: Update WMS filter when village changes
  useEffect(() => {
    if (isKhasraVisible && currentKhasraLayerRef.current) {
      // Construct filter
      let cqlFilter = `state='${selectedState}' AND district='${selectedDistrict}' AND tehsil='${selectedTehsil}'`;
      if (villageName) {
        cqlFilter += ` AND village='${villageName}'`;
      }

      // Update WMS Params
      currentKhasraLayerRef.current.setParams({ CQL_FILTER: cqlFilter });

      // Update Click Handler too
      const map = mapInstanceRef.current;
      setupKhasraClickHandler(map, currentKhasraLayerRef.current, villageName, selectedTehsil);
      console.log("🔄 Khasra filter updated for village:", villageName);
    }
  }, [villageName, selectedTehsil, selectedState, selectedDistrict, isKhasraVisible]);

  // 3. Ensure Khasra stays on top of other layers
  const ensureKhasraOnTop = () => {
    if (currentKhasraLayerRef.current && isKhasraVisible) {
      if (!mapInstanceRef.current.getPane("khasraPane")) {
        mapInstanceRef.current.createPane("khasraPane");
        mapInstanceRef.current.getPane("khasraPane").style.zIndex = 550;
      }
      mapInstanceRef.current.getPane("khasraPane").style.zIndex = 550;
      if (lulcLayerRef.current && showLULC) {
        lulcLayerRef.current.setZIndex(500);
      }
    }
  };

  useEffect(() => {
    return () => {
      // Cleanup when component unmounts
      if (mapInstanceRef.current) {
        mapInstanceRef.current.off("click");
        if (khasraHighlightRef.current) {
          mapInstanceRef.current.removeLayer(khasraHighlightRef.current);
        }
        if (currentKhasraLayerRef.current) {
          mapInstanceRef.current.removeLayer(currentKhasraLayerRef.current);
        }
      }
    };
  }, []);



  const activeOverlayRef = useRef(null);

  const toggleTrueColorOverlay = (imageUrl, layer, imageBbox) => {
    if (!imageUrl || !layer) {
      console.error("Image URL or layer is undefined");
      return;
    }
    if (activeOverlayRef.current) {
      activeOverlayRef.current.remove();
      activeOverlayRef.current = null;
    }
    if (layer.overlay) {
      layer.overlay.remove();
      layer.overlay = null;
    }
    // Use bbox in priority: per-image bbox → top-level response bbox → geometry bounds
    const bboxToUse = imageBbox || window._lastNdviBbox;
    let bounds;
    if (bboxToUse && bboxToUse.length === 4) {
      bounds = L.latLngBounds(
        L.latLng(bboxToUse[1], bboxToUse[0]),
        L.latLng(bboxToUse[3], bboxToUse[2])
      );
    } else if (layer.feature && layer.feature.geometry) {
      bounds = L.geoJSON(layer.feature.geometry).getBounds();
    } else {
      bounds = layer.getBounds();
    }
    if (!bounds || !bounds.isValid() || !layer._map) {
      console.error("Invalid bounds or layer not associated with map");
      return;
    }
    const overlay = L.imageOverlay(imageUrl, bounds, { opacity: 1 }).addTo(layer._map);
    layer.overlay = overlay;
    activeOverlayRef.current = overlay;
  };

  const toggleTrueColorImage = (clickedDate) => {
    if (
      !chartData.TrueColor ||
      !chartData.TrueColor.images ||
      chartData.TrueColor.images.length === 0
    ) {
      console.warn("TrueColor data is not available.");
      return;
    }

    const image = chartData.TrueColor.images.find(
      (img) => img.date === clickedDate
    );

    if (image && selectedPolygon) {
      toggleTrueColorOverlay(image.image_url, selectedPolygon, image.bbox);
    } else {
      console.warn(`No TrueColor image found for date: ${clickedDate}`);
    }
  };

  useEffect(() => {
    const optimizedChartData = {
      NDVI: {
        labels: chartData.NDVI.labels,
        values: chartData.NDVI.values,
        activePoints: chartData.NDVI.activePoints,  // ✅ include this
      },
      EVI: {
        labels: chartData.EVI.labels,
        values: chartData.EVI.values,
        activePoints: chartData.EVI.activePoints,  // ✅ include this
      },
      NDMI: {
        labels: chartData.NDMI.labels,
        values: chartData.NDMI.values,
        activePoints: chartData.NDMI.activePoints,  // ✅ include this
      },
      SVHI: {
        labels: chartData.SVHI.labels,
        values: chartData.SVHI.values,
        activePoints: chartData.SVHI.activePoints,  // ✅ include this
      },
    };

    localStorage.setItem("chartData", JSON.stringify(optimizedChartData));
    localStorage.setItem("selectedIndices", JSON.stringify(selectedIndices));
  }, [chartData, selectedIndices]);

  /* ---------- Chart Interaction ---------- */
  const handleIndexClick = (index) => {
    if (selectedIndices.includes(index)) {
      if (selectedIndices.length > 1) {
        dispatch(setSelectedIndices(selectedIndices.filter((i) => i !== index)));
      }
    } else {
      dispatch(setSelectedIndices([...selectedIndices, index]));
    }
  };




  const handleViewMore = () => {
    // ✅ FIX: If in-memory weatherData is stale/empty (e.g. after returning from weather page),
    // use the compressed data from sessionStorage which is always kept fresh by fetchPolygonNDVI.
    let compressedWeatherData;
    if (weatherData && weatherData.length > 0) {
      // In-memory data is fresh — compress and pass it
      compressedWeatherData = LZString.compress(JSON.stringify(weatherData));
      // Also keep sessionStorage in sync for future navigations
      sessionStorage.setItem("weatherData", compressedWeatherData);
    } else {
      // In-memory state is empty (component re-mounted after returning from weather page).
      // Re-use the compressed data already stored in sessionStorage by the last fetchPolygonNDVI call.
      compressedWeatherData = sessionStorage.getItem("weatherData") || LZString.compress(JSON.stringify([]));
    }

    sessionStorage.setItem("fromWeather", "true");
    navigate("/climate/weather", {
      state: {
        weatherData: compressedWeatherData,
        selectedDistrict,
        selectedTehsil,
        selectedSeason,
        selectedDate,
        villageName,
      },
    });
  };




  const handleSeasonChange = (e) => {
    const season = e.target.value;
    dispatch(setSelectedSeason(season));

    let start, end;

    if (season === "Kharif") {
      start = `${selectedYear}-06-01`;
      end = `${selectedYear}-10-31`;
    } else if (season === "Rabi") {
      start = `${selectedYear - 1}-11-15`;
      end = `${selectedYear}-03-30`;
    }

    dispatch(setStartDate(start));
    dispatch(setEndDate(end));

    localStorage.setItem("startDate", start);
    localStorage.setItem("endDate", end);
  };

  const handleYearChange = (e) => {
    const year = parseInt(e.target.value, 10);
    dispatch(setSelectedYear(year));

    let start, end;

    if (selectedSeason === "Kharif") {
      start = `${year}-06-01`;
      end = `${year}-10-31`;
    } else if (selectedSeason === "Rabi") {
      start = `${year - 1}-11-15`;
      end = `${year}-03-30`;
    }

    if (selectedSeason) {
      dispatch(setStartDate(start));
      dispatch(setEndDate(end));
      localStorage.setItem("startDate", start);
      localStorage.setItem("endDate", end);
    } else {
      console.warn("No season selected. Year change will not update dates.");
    }
  };

  const renderControlPanel = () => {
    return (
      <div className="control-panel">
        {/* <select
          className="modern-dropdown"
          value={selectedState}
          onChange={handleStateChange}
        >
          <option value="">State</option>
          {[
            "Andhra Pradesh",
            "Karnataka",
            "Maharashtra",
            "Rajasthan",
            "Uttar Pradesh",
          ]
            .sort()
            .map((state) => (
              <option key={state} value={state}>
                {state}
              </option>
            ))}
        </select>

        <select
          className="modern-dropdown"
          value={selectedDistrict}
          onChange={handleDistrictChange}
        >
          <option value="">District</option>
          {districts.map((district, index) => (
            <option key={index} value={district}>
              {district}
            </option>
          ))}
        </select>

        <select
          className="modern-dropdown"
          value={selectedTehsil}
          onChange={handleTehsilChange}
          disabled={!selectedDistrict}
        >
          <option value="">Tehsil</option>
          {tehsils.map((tehsil, index) => (
            <option key={index} value={tehsil}>
              {tehsil}
            </option>
          ))}
        </select>

        <select
          className="modern-dropdown"
          value={villageName}
          onChange={(e) => {
            const val = e.target.value;
            dispatch(setVillageName(val));
            localStorage.setItem("selectedVillage", val);
          }}
          disabled={!selectedTehsil}
        >
          <option value="">Village</option>
          {villages.map((village, index) => (
            <option key={index} value={village}>
              {village}
            </option>
          ))}
        </select> */}

        <SelectionDropdown onSearch={handleSearch} />

      <div className="button-container">

        <button
          onClick={handleKhasraToggle}
          className={`modern-btn ${isKhasraVisible ? "toggle-active" : "toggle-inactive"
            }`}
          disabled={!selectedState || !selectedTehsil || !villageName}
        >
          {isKhasraVisible ? "Hide Khasra" : "Show Khasra"}
        </button>

        <button
          onClick={() => {
            if (satelliteLayerRef.current) {
              if (isSatelliteVisible) {
                satelliteLayerRef.current.setOpacity(0);
              } else {
                satelliteLayerRef.current.setOpacity(1);
              }
              setIsSatelliteVisible(!isSatelliteVisible);
            }
          }}
          className={`modern-btn ${isSatelliteVisible ? "toggle-active" : "toggle-inactive"
            }`}
        >
          {isSatelliteVisible ? "Hide Satellite" : "Show Satellite"}
        </button>

        <button onClick={handleSearch} className="modern-btn primary">
          Search
        </button>

        <button onClick={handleViewMore} className="modern-btn primary">
          Next
        </button>

        <button onClick={toggleDrawer} className="modern-btn secondary">
          {isDrawerOpen ? "Close Panel" : "Open Panel"}
        </button>
        </div>
      </div>
    );
  };

  const renderBottomPanel = () => {
    if (!villageName) return null; // ✅ ONLY SHOW FOR VILLAGE
    if (screenSize.isMobile) {
      return (
        <div className={`bottom-panel ${isDrawerOpen ? "open" : "closed"}`}>
          <div className="control-section">
            <div className="control-card">
              <div className="season-year-controls">
                <select
                  value={selectedSeason}
                  onChange={handleSeasonChange}
                  className="control-select"
                >
                  <option value="">Season</option>
                  <option value="Kharif">Kharif</option>
                  <option value="Rabi">Rabi</option>
                </select>

                <select
                  value={selectedYear}
                  onChange={handleYearChange}
                  className="control-select"
                >
                  <option value="">Year</option>
                  <option value="2026">2026</option>
                  <option value="2025">2025</option>
                  <option value="2024">2024</option>
                  <option value="2023">2023</option>
                  <option value="2022">2022</option>
                </select>
              </div>

              <div className="controls-container">
                <div className="index-buttons-container">
                  <div className="index-buttons-title">Indices</div>
                  <div className="index-buttons">
                    {["NDVI", "NDMI", "EVI", "SVHI"].map((index) => (
                      <div
                        key={index}
                        className="index-button-container"
                        onMouseEnter={() => setHoveredIndex(index)}
                        onMouseLeave={() => setHoveredIndex(null)}
                      >
                        <button
                          onClick={() => {
                            if (
                              selectedIndices.includes(index) &&
                              selectedIndices.length === 1
                            )
                              return;
                            handleIndexClick(index);
                          }}
                          className={`index-btn ${selectedIndices.includes(index)
                            ? index.toLowerCase()
                            : "inactive"
                            } hover-lift`}
                        >
                          {index}
                        </button>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="date-section-container">
                  <div className="date-section-title">Dates</div>
                  <div className="date-section">
                    <div className="date-row">
                      <label htmlFor="start-date" className="date-label">
                        Start:
                      </label>
                      <input
                        type="text"
                        id="start-date"
                        value={startDate}
                        readOnly
                        className="date-input"
                      />
                    </div>

                    <div className="date-row">
                      <label htmlFor="end-date" className="date-label">
                        End:
                      </label>
                      <input
                        type="text"
                        id="end-date"
                        value={selectedDate}
                        readOnly
                        className="date-input"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="chart-section">
            {selectedPolygon && selectedIndices.length > 0 && (
              <div className="charts-grid-layout">
                {selectedIndices.map((index) => (
                  <div key={index} className="chart-card-modern">
                    <div className="chart-card-header">{index} Analysis</div>
                    <div className="chart-card-body">
                      <NDVIChart
                        chartData={chartData}
                        selectedIndices={[index]}
                        selectedPolygon={selectedPolygon}
                        activePointsData={chartData?.[index]?.activePoints || []}
                        onDateLabelClick={toggleTrueColorImage}
                        screenSize={screenSize}
                        seasonalScores={seasonalScores}
                        mapInstanceRef={mapInstanceRef}
                        isStressView={index === "SVHI" || index === "BIOTIC" || index === "ABIOTIC"}
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}
            <div className="chart-source">Source: Sentinel-2 imagery</div>
          </div>
        </div>
      );
    }
    
    return (
      <div className={`bottom-panel ${isDrawerOpen ? "open" : "closed"}`}>
        <div className="control-section">
          <div className="control-card">
            <div className="season-year-controls">
              <select
                value={selectedSeason}
                onChange={handleSeasonChange}
                className="control-select"
              >
                <option value="">Season</option>
                <option value="Kharif">Kharif</option>
                <option value="Rabi">Rabi</option>
              </select>

              <select
                value={selectedYear}
                onChange={handleYearChange}
                className="control-select"
              >
                <option value="">Year</option>
                <option value="2026">2026</option>
                <option value="2025">2025</option>
                <option value="2024">2024</option>
                <option value="2023">2023</option>
                <option value="2022">2022</option>
              </select>
            </div>

            <div className="controls-container">
              <div className="index-buttons-container">
                <div className="index-buttons-title">Select Indices</div>
                <div className="index-buttons">
                  {["NDVI", "NDMI", "EVI", "SVHI"].map((index) => (
                    <div
                      key={index}
                      className="index-button-container"
                      onMouseEnter={(e) => {
                        setHoveredIndex(index);
                        const rect = e.currentTarget.getBoundingClientRect();
                        setTooltipPos({
                          top: rect.top,
                          left: rect.left, // Align with left edge of button
                          width: rect.width
                        });
                      }}
                      onMouseLeave={() => setHoveredIndex(null)}
                    >
                      <button
                        onClick={() => {
                          if (
                            selectedIndices.includes(index) &&
                            selectedIndices.length === 1
                          )
                            return;
                          handleIndexClick(index);
                        }}
                        className={`index-btn ${selectedIndices.includes(index)
                          ? index.toLowerCase()
                          : "inactive"
                          } hover-lift`}
                      >
                        {index}
                      </button>

                    </div>
                  ))}
                </div>
              </div>

              <div className="date-section-container">
                <div className="date-section-title">Date Range</div>
                <div className="date-section">
                  <div className="date-row">
                    <label htmlFor="start-date" className="date-label">
                      Start Date:
                    </label>
                    <input
                      type="text"
                      id="start-date"
                      value={startDate}
                      readOnly
                      className="date-input"
                    />
                  </div>

                  <div className="date-row">
                    <label htmlFor="end-date" className="date-label">
                      End Date:
                    </label>
                    <input
                      type="text"
                      id="end-date"
                      value={selectedDate}
                      readOnly
                      className="date-input"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="chart-section">
          {selectedPolygon && selectedIndices.length > 0 && (
            <div className="charts-grid-layout">
              {selectedIndices.map((index) => (
                <div key={index} className="chart-card-modern">
                  <div className="chart-card-header">{index} Analysis</div>
                  <div className="chart-card-body">
                    <NDVIChart
                      chartData={chartData}
                      selectedIndices={[index]}
                      selectedPolygon={selectedPolygon}
                      activePointsData={chartData?.[index]?.activePoints || []}
                      onDateLabelClick={toggleTrueColorImage}
                      screenSize={screenSize}
                      seasonalScores={seasonalScores}
                      mapInstanceRef={mapInstanceRef}
                      isStressView={index === "SVHI" || index === "BIOTIC" || index === "ABIOTIC"}
                    />
                  </div>
                </div>
              ))}
            </div>
          )}
          <div className="chart-source">Source: Sentinel-2 imagery</div>
        </div>
      </div>
    );
  };

  return (
    <>
      {showWeather ? (
        <WeatherDetailsView
          selectedIndices={selectedIndices}
          selectedPolygon={selectedPolygon}
          activePointsData={chartData?.[selectedIndices[0]]?.activePoints || []}
        />
      ) : (
        <div className="indices-analytics">
          <div className="dashboard-header">
            <h3>Indices Dashboard</h3>
          </div>

          <div className="dashboard-main-content">
            <div
              className={`map-container ${isDrawerOpen ? "drawer-open" : "drawer-closed"
                }`}
            >
              {isDropdownLoading && <Spinner />}
              {renderControlPanel()}
              <div ref={mapRef} id="map">
              </div>

              {/* Desktop: ScoreCard inside map-container for absolute overlay */}
              {villageName && !screenSize.isMobile && !screenSize.isTablet && (
                <div className="scorecard-wrapper">
                  <ScoreCard
                    chartData={chartData}
                    selectedSeason={selectedSeason}
                    selectedIndices={selectedIndices}
                    screenSize={screenSize}
                    seasonalScores={seasonalScores}
                  />
                </div>
              )}

              {loading && <Spinner />}
              <ProgressBar loading={loading} progress={progress} />
            </div>

            {/* Mobile/Tablet: ScoreCard outside map-container for natural flow */}
            {villageName && (screenSize.isMobile || screenSize.isTablet) && (
              <div className="scorecard-wrapper scorecard-wrapper-mobile">
                <ScoreCard
                  chartData={chartData}
                  selectedSeason={selectedSeason}
                  selectedIndices={selectedIndices}
                  screenSize={screenSize}
                  seasonalScores={seasonalScores}
                />
              </div>
            )}

            {renderBottomPanel()}
          </div>

          {/* NEW: Stress Analysis Modal */}

        </div>
      )}

      {/* Global Floating Tooltip - Renders on top of everything */}
      {hoveredIndex && !screenSize.isMobile && tooltipPos && (
        <div
          className="floating-tooltip"
          style={{
            top: tooltipPos.top - 12, // 12px gap above button
            left: tooltipPos.left,
            transform: "translateY(-100%)", // Move up by its own height
            // Ensure strictly on screen (optional, but CSS width clamp helps)
          }}
        >
          {tooltipTexts[hoveredIndex]}
        </div>
      )}
    </>
  );
};

// Helper: Ray Casting Algorithm for Point-in-Polygon
const isPointInPoly = (point, vs) => {
  // point = [lng, lat], vs = [[lng, lat], ...]
  var x = point[0], y = point[1];
  var inside = false;
  for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
    var xi = vs[i][0], yi = vs[i][1];
    var xj = vs[j][0], yj = vs[j][1];
    var intersect = ((yi > y) != (yj > y)) &&
      (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
    if (intersect) inside = !inside;
  }
  return inside;
};

// Helper: Check GeoJSON Geometry
const isInsideGeoJSON = (lat, lng, geometry) => {
  const pt = [lng, lat]; // GeoJSON coordinates are [lng, lat]
  if (geometry.type === "Polygon") {
    // Check outer ring (index 0)
    return isPointInPoly(pt, geometry.coordinates[0]);
  } else if (geometry.type === "MultiPolygon") {
    // Check any polygon in the multipolygon
    return geometry.coordinates.some(poly => isPointInPoly(pt, poly[0]));
  }
  return false;
};

export default IndicesAnalytics;


